import { render, staticRenderFns } from "./undo-endorsement.vue?vue&type=template&id=6a0b0468&scoped=true&"
import script from "./undo-endorsement.vue?vue&type=script&lang=js&"
export * from "./undo-endorsement.vue?vue&type=script&lang=js&"
import style0 from "./undo-endorsement.vue?vue&type=style&index=0&id=6a0b0468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b0468",
  null
  
)

export default component.exports